import React from 'react';
import { connect } from 'react-redux';
import TextField from '@material-ui/core/TextField';
import { intlShape, injectIntl } from 'react-intl';
import { TypeTextIcon } from '../../../../images/icons/WrapSvg';

import { bindActionCreators } from 'redux';
import * as actions from '../../../../actions/api.form.actions';

import Task from './Task';

class Text extends React.Component {
    state = {
        valor: '',
        comment: '',
        point: 0,
        correction: 0,
        message: undefined,
        intervalId: undefined,
        desactivado: false,
        disabledmodoTest: false
    };

    static getDerivedStateFromProps(props, state) {
        const { data, parentDeactivated } = props;
        if (data !== state.data || parentDeactivated !== state.parentDeactivated) {
            state.valor = data.valor;
            state.desactivado = data.desactivado;
            state.parentDeactivated = parentDeactivated;
            state.data = data;
            return state;
        }
        return null;
    }

    handleChange = (valor, name) => {
        this.props.setValue(name, valor, '', false, {});
        this.setState({ valor: valor });
    };

    handleClick = (name) => {
        if (!this.props.data.disabled && document.getElementById(name)) {
            document.getElementById(name).focus();
        }
    };

    handleDeactive = (data, checked) => {
        this.props.setValue(data.codigo, undefined, '', checked, {});
        this.setState({ desactivado: checked, valor: '' });
    }

    handleFocus = () => {
        const { data, valor } = this.state;
        if(data.modoTest && valor) {
            this.setState({  disabledmodoTest:  true });
        }
    }

    component = (name, intl, disabled, disabledmodoTest) => {
        if (disabled) {
            return (
                <span className="barlow_regular_textwrap c_slate text_align_left">
                    {this.state.valor}
                </span>
            );
        } else {
            return (
                <TextField
                    fullWidth
                    multiline
                    name={name}
                    id={name}
                    disabled={disabledmodoTest}
                    onFocus={this.handleFocus} 
                    label={intl.formatMessage({ id: 'text_field_label' })}
                    value={this.state.valor !== null ? this.state.valor : ''}
                    onChange={(event) => this.handleChange(event.target.value, name)}
                />
            );
        }
    };

    render() {
        const { last, intl, editable } = this.props;
        const { data, valor, desactivado, parentDeactivated, disabledmodoTest } = this.state;
        return (
            <Task
                key={data.codigo}
                data={data}
                value={valor}
                desactivado={desactivado || parentDeactivated}
                icon={<TypeTextIcon color="primary" />}
                text="type_label_text"
                last={last}
                editable={editable}
                component={this.component(
                    data.codigo,
                    intl,
                    !editable || data.disabled || desactivado || parentDeactivated,
                    disabledmodoTest
                )}
                parentDeactivated={parentDeactivated}
                onClick={() => this.handleClick(data.codigo)}
                onDeactive={this.handleDeactive}
            />
        );
    }
}

Text.propTypes = {
    intl: intlShape.isRequired,
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(Object.assign({}, actions), dispatch);
};

export default connect(
    undefined,
    mapDispatchToProps,
)(injectIntl(Text));



// WEBPACK FOOTER //
// ./src/components/complex/forms/types/Text.js